import {CLTableSearchParamKey} from 'common/src/components/CLTable/CLTable.types';
import {AdservingPartnerWithMacros} from 'common/src/modules/adServingPartner/adServingPartner.types';
import {Routes} from 'common/src/modules/routing/routing.config';
import {Resource} from 'common/src/modules/shared/copilot/copilot.types';

function buildDspResourceLink(dsp?: AdservingPartnerWithMacros): Resource {
  // if dsp is undefined, return a link to all DSPs and publishers
  if (!dsp) {
    return {
      title: 'DSPs & Publishers',
      link: {
        url: Routes.DspLibrary,
      },
    };
  }

  return {
    title: dsp.partner.displayName,
    link: {
      url: Routes.DspLibrary,
      queryParams: {[CLTableSearchParamKey.Filter]: dsp.partner.displayName},
    },
  };
}

export default buildDspResourceLink;
